// ZZZ URL alias: /game/guide/zzz/wengine/<id> renders the same detail page
// as /weapon/<id> (the component adapts its labels per game).
// getStaticPaths/getStaticProps must be re-exported explicitly — Next.js does
// not pick up data-fetching functions through `export { default }`.
export { default, getStaticPaths, getStaticProps } from '../weapon/[weaponId]'
